<template>
  <div>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-card>
                <personnel-record-deadlines-data-table
                  :deadlines="deadlinesCache.entries"
                  showDeadline
                  showHistory
                  showDocuments
                  allowGrouping
                  allowGroupingByDeadline
                  allowGroupingByStatus
                ></personnel-record-deadlines-data-table> </v-card
            ></v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import PersonnelRecordDeadlinesDataTable from "@/components/member-management/personnel-records/PersonnelRecordDeadlinesDataTable.vue";
export default {
  name: "member-management-personnel-records-details-physicals",
  components: {
    PersonnelRecordDeadlinesDataTable,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: true,
      },
      deadlinesCache: null,
    };
  },
  watch: {
    $route: "initialize",
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDeadlineEntries();
    },
    getDeadlineEntries() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("deadlinesCache")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.deadlinesCache = doc.data();
            this.helpers.dataIsLoading = false;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
  },
};
</script>

<style></style>
